import { UserCircleIcon } from "@heroicons/react/24/outline";
import { cn } from "helpers/classNames";

type Props = {
  className?: string;
};

export const CustomerIcon = ({ className }: Props) => (
  <UserCircleIcon className={cn("h-4 w-4 text-gray-400", className)} />
);
